/**
 * Collection Combo Carousel Controller
 * Adheres strictly to Shopify CRO Development Guidelines:
 * - Scoped logic without global pollution
 * - Pure data-* attribute selectors
 * - Defensive coding with guards and try/catch
 */

(function () {
  'use strict';

  /**
   * Scrolls carousel track smoothly
   * @param {HTMLElement} track
   * @param {'prev'|'next'} direction
   */
  function scrollCarouselTrack(track, direction) {
    try {
      if (!track) return;
      const scrollAmount = track.clientWidth * 0.75;
      const delta = direction === 'next' ? scrollAmount : -scrollAmount;
      track.scrollBy({ left: delta, behavior: 'smooth' });
    } catch (err) {
      console.warn('[CollectionComboCarousel] Scroll error:', err);
    }
  }

  /**
   * Initializes a single combo carousel section instance
   * @param {HTMLElement} section
   */
  function initComboCarousel(section) {
    try {
      if (!section) return;
      if (section.getAttribute('data-carousel-initialized') === 'true') return;
      section.setAttribute('data-carousel-initialized', 'true');

      const track = section.querySelector('[data-carousel-track]');
      if (!track) return;

      const prevBtn = section.querySelector('[data-action="carousel-prev"]');
      const nextBtn = section.querySelector('[data-action="carousel-next"]');

      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          scrollCarouselTrack(track, 'prev');
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          scrollCarouselTrack(track, 'next');
        });
      }
    } catch (err) {
      console.warn('[CollectionComboCarousel] Init error:', err);
    }
  }

  /**
   * Discovers and initializes all combo carousels on the page
   */
  function initAllCarousels() {
    try {
      const carousels = document.querySelectorAll('[data-combo-carousel]');
      carousels.forEach(function (carousel) {
        initComboCarousel(carousel);
      });
    } catch (err) {
      console.warn('[CollectionComboCarousel] Setup error:', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    initAllCarousels();
  }

  // Handle Shopify theme editor section reload events
  document.addEventListener('shopify:section:load', function (e) {
    try {
      if (e.target) {
        const carousel = e.target.querySelector('[data-combo-carousel]');
        if (carousel) initComboCarousel(carousel);
      }
    } catch (_) {}
  });
})();
